import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import { allowMultipleToast } from 'vant';
import 'vant/lib/index.css';
import '@/assets/style.less'
import axios from 'axios'
import qs from 'qs'
import request from '@/utils/request.js'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'

const app=createApp(App);
app.use(Vant)
app.use(router)
app.use(store)
app.use(ElementPlus)
app.mount('#app')
// router.beforeEach((to, from, next) => {
//     if(to.meta.title){
//         document.title = to.meta.title;
//     }
//     next()
// })

// 配置全局属性
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$http= 'http://alserver.zhihexuntech.com';
app.config.globalProperties.$qs= qs;
app.config.globalProperties.$request= request;

allowMultipleToast()
